module.exports = "/_next/static/images/005ad75370651fa2c662655123537ad2-cajitas-left-mobile.jpg.webp";